// --- Services ---
import Api from '@/services/api';

export default {

  notMomentumMember(params: { isMomentumMember: boolean; }) {
    return Api().post('/auth/no_momentum', params);
  },

  getMomentumDiscount(params: { momentumCode: string; transactionValue: string; transactionIdentifier: string; }) {
    return Api().post('/auth/momentum', params);
  },
};
